import { Route, Routes, Navigate } from 'react-router-dom';
import { PredictionsPage } from './pages';
import { PositionsPage } from './pages/PositionsPage';
import { EconomicsPage } from './pages/EconomicsPage';
import { UnwindingPage } from './pages/UnwindingPage';
import { EntryPage } from './pages/EntryPage';
import { BucketPage } from './pages/BucketPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { PredictionMapperPage } from 'src/Modules/PredictionMapper';
import { PredictionsStatus } from 'src/Modules/Arbitrage/pages/PredictionsStatus';
import { PredictionsProviders } from './Providers';
import { PositionsProvider } from './context';
import { UpdatesProvider } from 'src/Modules/Arbitrage/context/updatesContext';

export const PredictionsRouter = () => {
  return (
    <Routes>
      <Route
        path="opportunities"
        element={
          <PredictionsProviders>
            <PredictionsPage />
          </PredictionsProviders>
        }
      />
      <Route
        path="positions"
        element={
          <PositionsProvider>
            <PositionsPage />
          </PositionsProvider>
        }
      />
      <Route path="economics" element={<EconomicsPage />} />
      <Route path="costs" element={<Navigate to="/predictions/economics" replace />} />
      <Route
        path="unwinding"
        element={
          <UpdatesProvider scope="predictions">
            <UnwindingPage />
          </UpdatesProvider>
        }
      />
      {/* PositionsProvider supplies the `/predictions` socket the per-group
          live summary strip reads (`group_live_position`) while operating. */}
      <Route
        path="opening"
        element={
          <UpdatesProvider scope="predictions">
            <PositionsProvider>
              <EntryPage />
            </PositionsProvider>
          </UpdatesProvider>
        }
      />
      <Route path="opening/bucket" element={<BucketPage />} />
      <Route path="entry" element={<Navigate replace to="../opening" />} />
      <Route path="notifications" element={<NotificationsPage />} />
      <Route path="mapper" element={<PredictionMapperPage />} />
      <Route path="status" element={<PredictionsStatus />} />
      <Route path="*" element={<Navigate replace to="opportunities" />} />
    </Routes>
  );
};
